module.exports = __webpack_public_path__ + "img/cash-managment-2.3de4c3c4.png";